var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCreateTask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 3.75C15.5039 3.75 3.75 15.5039 3.75 30C3.75 44.4961 15.5039 56.25 30 56.25C44.4961 56.25 56.25 44.4961 56.25 30C56.25 15.5039 44.4961 3.75 30 3.75ZM41.25 31.4062C41.25 31.6641 41.0391 31.875 40.7812 31.875H31.875V40.7812C31.875 41.0391 31.6641 41.25 31.4062 41.25H28.5938C28.3359 41.25 28.125 41.0391 28.125 40.7812V31.875H19.2188C18.9609 31.875 18.75 31.6641 18.75 31.4062V28.5938C18.75 28.3359 18.9609 28.125 19.2188 28.125H28.125V19.2188C28.125 18.9609 28.3359 18.75 28.5938 18.75H31.4062C31.6641 18.75 31.875 18.9609 31.875 19.2188V28.125H40.7812C41.0391 28.125 41.25 28.3359 41.25 28.5938V31.4062Z",
    fill: "#0077D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateTask);
export default __webpack_public_path__ + "static/media/create-task.7ba0dc85bdc8503534828829ffb8d8f5.svg";
export { ForwardRef as ReactComponent };